import { render, staticRenderFns } from "./auditMargin.vue?vue&type=template&id=86103852&scoped=true&"
import script from "./auditMargin.vue?vue&type=script&lang=js&"
export * from "./auditMargin.vue?vue&type=script&lang=js&"
import style0 from "./auditMargin.vue?vue&type=style&index=0&id=86103852&prod&lang=less&scoped=true&"
import style1 from "./auditMargin.vue?vue&type=style&index=1&id=86103852&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86103852",
  null
  
)

export default component.exports